function Section2() {
    return (
        <div className="main2">
            <p>Development</p>
            <p>Business</p>
            <p>IT & Software</p>
            <p>Personal Development</p>
            <p>Design</p>
            <p>Marketing</p>
        </div>
    )
}

export default Section2